import { endOfWeek, startOfWeek } from 'date-fns';

const getDateRange = date => ({ start: startOfWeek(date, { weekStartsOn: 1 }), end: endOfWeek(date, { weekStartsOn: 1 }) });

export default getDateRange;
